<!--
 * @Author: your name
 * @Date: 2021-11-24 16:23:09
 * @LastEditTime: 2022-02-15 14:59:14
 * @LastEditors: Please set LastEditors
 * @Description: 首页 媒体动态
 * @FilePath: \new-website-1123\src\views\Home\media\index.vue
-->
<template>
  <div class="programme-swiper">
    <div class="home-media">
      <div class="content-div pt80">
        <div class="title-div">
          <h-title :titleimg="titleimg" :stitleimg="stitleimg"></h-title>
        </div>
        <m-nav
          :navList="navList"
          :active="navActive"
          @change="navChange"
        ></m-nav>
      </div>
      <div class="right-div">
        <img :src="currentItem.cover" alt="" />
      </div>
    </div>
    <div class="home-media-moile">
      <h-title :titleimg="titleimg" :stitleimg="stitleimg"></h-title>
      <swiper
        class="right-divmap swiper"
        ref="swiper"
        :options="swiperOptions"
        @slideChange="slideChange"
      >
        <swiper-slide v-for="item in advantageList" :key="item.key">
          <slot :row="item">
            <div class="right-divmap-connect">
              <img
                class="data-img"
                :src="item.cover"
                alt=""
                :style="{
                  'object-fit': 'cover',
                }"
              />
              <div class="views">
                <h2>{{ item.label }}</h2>
                <h4>{{ item.time }}</h4>
                <h6>查看详情 ></h6>
              </div>
            </div>

            <div class="filter-div"></div>
          </slot>
        </swiper-slide>
        <div class="home-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import hTitle from "../components/title.vue";
import mNav from "./nav.vue";
export default {
  name: "",
  components: { hTitle, mNav },
  data() {
    let w = window.innerWidth > 800 ? 5 : 1;
    return {
      swiperOptions: {
        pagination: {
          el: ".home-media-moile .home-pagination",
          clickable: true,
        },
        autoplay: true,
        loop: true,
        speed: 800,
        mousewheel: false,
        slidesPerGroup: 1,
        loopedSlides: w,
        spaceBetween: 20,
      },
      titleimg: require("@/assets/images/programme/common/whitetitle3.png"),
      stitleimg: require("@/assets/images/programme/common/whitetitle3s.png"),
      advantageList: [
        {
          key: 1,
          label: "财政部、国家粮食和物资储备局发文，深入推进优质粮食工程",
          time: "4天前",
          cover: require("../../../assets/images/news/newsimg1.jpg"),
        },
        {
          key: 2,
          label: "农业农村部乡村产业发展司负责人:拓展农业多种功能 提升乡村",
          time: "2021.11.08",
          cover: require("../../../assets/images/news/newsimg2.jpg"),
        },
        {
          key: 3,
          label: "国家乡村振兴局：23项可申请补贴项目！",
          time: "2021.10.28",
          cover: require("../../../assets/images/news/newsimg3.jpg"),
        },
        {
          key: 4,
          label: "实现“碳中和”，对农业将产生怎样的巨大影响？",
          time: "2021.08.08",
          cover: require("../../../assets/images/news/newsimg4.jpg"),
        },
      ],

      navList: [
        {
          id: 1,
          label: "财政部、国家粮食和物资储备局发文，深入推进优质粮食工程",
          time: "4天前",
          cover: require("../../../assets/images/news/newsimg1.jpg"),
        },
        {
          id: 2,
          label: "农业农村部乡村产业发展司负责人:拓展农业多种功能 提升乡村",
          time: "2021.11.08",
          cover: require("../../../assets/images/news/newsimg2.jpg"),
        },
        {
          id: 3,
          label: "国家乡村振兴局：23项可申请补贴项目！",
          time: "2021.10.28",
          cover: require("../../../assets/images/news/newsimg3.jpg"),
        },
        {
          id: 4,
          label: "实现“碳中和”，对农业将产生怎样的巨大影响？",
          time: "2021.08.08",
          cover: require("../../../assets/images/news/newsimg4.jpg"),
        },
      ],
      navActive: 1,
    };
  },
  created() {},
  computed: {
    currentItem() {
      return this.navList.filter((item) => item.id == this.navActive)[0];
    },
  },
  methods: {
    navChange(val) {
      this.navActive = val;
    },
    slideChange() {
      this.$emit("change", this.$refs.swiper.$swiper.realIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.home-media {
  width: 100%;
  height: 100vh;
  display: flex;
  .content-div {
    padding-left: 11vw;
    width: 49%;
    padding-right: 50px;
    .title-div {
      margin-bottom: 30px;
      padding-top: 30px;
    }
  }
  .right-div {
    width: 51%;
    height: 100%;
    overflow: hidden;
  }
}

.home-media-moile {
  text-align: center;
  display: none;
  .home-title {
    margin-bottom: 0.91rem;
  }
}
.programme-swiper {
  width: 100%;
  overflow: hidden;

  .desc-p {
    width: 1200px;
    text-align: center;
    color: rgba($color: #fff, $alpha: 0.7);
    font-size: 22px;
    font-weight: 400;
    line-height: 36px;
    margin: 50px auto;
  }

  .desc-paragraph {
    width: 1400px;
    text-align: center;
    color: rgba($color: #fff, $alpha: 0.7);
    font-size: 22px;
    font-weight: 400;
    line-height: 36px;
    margin: 50px auto;
  }

  @media screen and (max-width: 1400px) {
    .desc-p {
      width: 1100px;
      font-size: 18px;
    }
    .desc-paragraph {
      width: 1200px;
      font-size: 20px;
    }
  }
}
.home-pagination {
  position: absolute;
  bottom: -30px;
  text-align: center;
  top: auto;
  ::v-deep {
    .swiper-pagination-bullet {
      width: 24px;
      height: 3px;
      border-radius: 0;
      background-color: rgba($color: #fff, $alpha: 0.8);
      &.swiper-pagination-bullet-active {
        background-color: $color-active;
      }
    }
  }
}
.right-divmap {
  width: 100%;
}
.data-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.filter-div {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #161616;
  opacity: 0.4;
  transition: opacity 0.3s;
}

::v-deep {
  .swiper-container .swiper-wrapper .swiper-slide-active {
    width: 600px;
    .filter-div {
      // background-color: rgba($color: #161616, $alpha: 0);
      opacity: 0;
    }
  }
}
@media screen and (max-width: $mobile-width) {
  .home-media-moile {
    display: block;
    // height: 8.29rem;
  }

  .home-media {
    display: none;
  }

  .right-divmap {
    width: 86%;
    .right-divmap-connect {
      color: #fff;
      img {
        height: 5.76rem;
      }
      .views {
        padding-top: 0.27rem;
        padding-left: 0.69rem;
        background: rgba(255, 255, 255, 0.05);
        padding-right: 0.69rem;
        padding-bottom: 0.45rem;
        text-align: center;
        h2 {
          font-size: 0.36rem;
          font-weight: normal;
          line-height: 130%;
        }
        h4 {
          font-size: 0.2rem;
          color: rgba(255, 255, 255, 0.4);
          padding-top: 0.18rem;
          padding-bottom: 0.36rem;
        }
        h6 {
          color: $color-active;
          font-size: 0.25rem;
        }
      }
    }
  }
  .programme-swiper {
    padding: 0;

    width: 100%;
    overflow: unset;
    .desc-p {
      width: 86%;
      font-size: 0.27rem;
      line-height: 0.44rem;
      margin: 0.27rem auto;
    }

    .desc-paragraph {
      width: 86%;
      font-size: 0.27rem;
      line-height: 0.44rem;
      margin: 0.27rem auto;
    }
  }

  ::v-deep {
    .swiper-container {
      overflow: visible !important;
      width: 86vw;
      height: 5.91rem;
    }
    .swiper-container .swiper-wrapper .swiper-slide {
      width: 86vw;
      position: relative;
    }
    .swiper-container .swiper-wrapper .swiper-slide-prev {
      height: auto !important;
    }
    .swiper-container .swiper-wrapper .swiper-slide-prev img {
      height: 5.76rem !important;
    }
    .swiper-container .swiper-wrapper .swiper-slide-next {
      height: auto !important;
    }
    .swiper-container .swiper-wrapper .swiper-slide-next img {
      height: 5.76rem !important;
    }
    .swiper-container .swiper-wrapper .swiper-slide-active {
      .filter-div {
        // background-color: rgba($color: #161616, $alpha: 0);
        opacity: 0;
      }
    }
  }
}
</style>
